var map = {
	"./ecommerce/01.jpg": 98769,
	"./ecommerce/02.jpg": 71014,
	"./ecommerce/03.jpg": 14147,
	"./ecommerce/04.jpg": 37872,
	"./ecommerce/05.jpg": 90093,
	"./ecommerce/06.jpg": 44162,
	"./ecommerce/07.jpg": 35871,
	"./ecommerce/08.jpg": 77500,
	"./ecommerce/09.jpg": 98553,
	"./ecommerce/10.jpg": 35667,
	"./ecommerce/11.jpg": 72502,
	"./ecommerce/12.jpg": 62081,
	"./ecommerce/banner.jpg": 72478,
	"./ecommerce/card.png": 81322,
	"./ecommerce/icon-empty-cart.png": 61152,
	"./ecommerce/mastercard.png": 37320,
	"./ecommerce/paypal.png": 48613,
	"./ecommerce/product-table-1.png": 6006,
	"./ecommerce/product-table-2.png": 87629,
	"./ecommerce/product-table-3.png": 47684,
	"./ecommerce/product-table-4.png": 29339,
	"./ecommerce/product-table-5.png": 15122,
	"./ecommerce/product-table-6.png": 5833,
	"./ecommerce/visa.png": 29999
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84175;